/* EP Runde 14: ausgelagert aus snippets/ep-desc-popup.liquid. defer. */
(function () {
  'use strict';

  var DONE = 'data-epd';

  function productUrl(desc) {
    /* 1) Schnellansicht des Themes: Modal-ID = modal-{Produkt-ID}, Opener-Link hat dieselbe data-id */
    var modal = desc.closest('modal-box, .modal');
    if (modal && modal.id && modal.id.indexOf('modal-') === 0) {
      var pid = modal.id.slice(6);
      var opener = document.querySelector('quick-view-product a[data-id="' + pid + '"]');
      if (opener && opener.getAttribute('href')) return opener.getAttribute('href').split('?')[0];
    }
    /* 2) Produktlink im selben Popup (Titel, Bild) */
    var box = desc.parentElement;
    for (var i = 0; box && i < 12; i++, box = box.parentElement) {
      var links = box.querySelectorAll('a[href*="/products/"]');
      for (var j = 0; j < links.length; j++) {
        if (!desc.contains(links[j])) return links[j].getAttribute('href').split('?')[0];
      }
      if (box.matches && box.matches('modal-box, .modal, [role="dialog"]')) break;
    }
    /* 3) Variante aus dem Warenkorb-Formular – Shopify leitet /variants/ID auf die Produktseite weiter */
    box = desc.closest('modal-box, .modal, [role="dialog"], product-page') || desc.parentElement;
    var idInput = box ? box.querySelector('form[action*="/cart/add"] [name="id"]') : null;
    if (idInput && idInput.value) return '/variants/' + idInput.value;
    return '';
  }

  function hideTrailing(desc) {
    /* Inhalte, die in der Beschreibung NACH dem ep-short-Block stehen (z. B. Bilder) */
    var parent = desc.parentElement;
    if (!parent || parent.querySelector('form, button, select')) return;
    var el = desc.nextElementSibling;
    while (el) { el.classList.add('epd-hide'); el = el.nextElementSibling; }
  }

  function process(desc) {
    if (desc.hasAttribute(DONE) || desc.closest('#epn-side')) return;
    desc.setAttribute(DONE, '1');
    hideTrailing(desc);
    var url = productUrl(desc);
    if (!url) return;
    var a = document.createElement('a');
    a.className = 'epd-link';
    a.href = url;
    a.textContent = 'Alle Details zum Produkt';
    desc.appendChild(a);
  }

  function scan() {
    var list = document.querySelectorAll('.ep-short-product-description:not([' + DONE + '])');
    for (var i = 0; i < list.length; i++) process(list[i]);
  }

  var t = null;
  function start() {
    scan();
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
